import ReactDOM from 'react-dom/client';
import App from './App';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import 'swiper/css';
import 'tippy.js/dist/tippy.css';
import './scss/_index.scss';
import { store } from './store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
const queryClient = new QueryClient();
root.render(
  // <React.StrictMode>
    <Provider store={store}>
       <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
    </Provider>,
  
);
